import { render, staticRenderFns } from "./LgFinderPageDepartamentoSgu.vue?vue&type=template&id=30a431c4"
import script from "./LgFinderPageDepartamentoSgu.vue?vue&type=script&lang=js"
export * from "./LgFinderPageDepartamentoSgu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports